import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CryptoJS from "crypto-js";
export default {
  data: function data() {
    return {
      input: '',
      captcha: '',
      count: 0,
      show1: true,
      show2: false,
      show3: false
    };
  },
  methods: {
    //验证码
    sendMessage: function sendMessage() {
      var _this = this;

      var once = true;
      var str_ = Date.parse(new Date()) / 1000;
      var str = this.encryption(str_);
      var str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;

      if (once) {
        var that = this;
        this.$http.post("/api/XOrg/XLogin/sendCode", {
          verifyInfo: this.input,
          str: str,
          str1: str1
        }).then(function (rst) {
          if (rst.code > 0) {
            _this.$message.success(rst.msg);

            _this.verifyCode = rst.verifyCode;
            var TIME_COUNT = 60;

            if (!_this.timer) {
              _this.count = TIME_COUNT;
              _this.show1 = false;
              _this.show2 = true;
              _this.show3 = false;
              _this.timer = setInterval(function () {
                if (_this.count > 0 && _this.count <= TIME_COUNT) {
                  _this.count--;
                  once = false;
                } else {
                  _this.show1 = false;
                  _this.show2 = false;
                  _this.show3 = true;
                  clearInterval(_this.timer);
                  _this.timer = null;
                  once = true;
                }
              }, 1000);
            }
          } else {
            _this.$message.warning(rst.msg);
          }
        });
      }
    },
    encryption: function encryption(str) {
      var Base64 = require("js-base64").Base64;

      return Base64.encode(str);
    },
    updatePhone: function updatePhone() {
      var self = this;
      this.$http.post("/api/XOrg/AOrgInfo/updatePhone", {
        moblie: self.input,
        captcha: self.captcha
      }).then(function (res) {
        if (res.code == 1) {
          self.$message.success(res.msg);
        } else {
          self.$message.warning(res.msg);
        }
      });
    }
  }
};